// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-wrap {
  max-width: 720px;
  margin: 0 auto;
}

.session-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #0f766e;
  color: #fff;
  border-radius: 12px;
  margin-bottom: 16px;
}

.session-title {
  font-weight: 700;
}

.session-clock {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.session-clock-low {
  color: #fde68a;
}

.session-quit {
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: transparent;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.session-end {
  max-width: 480px;
  margin: 40px auto;
  text-align: center;
  background: #fff;
  border: 1px solid #d7e6e3;
  border-radius: 16px;
  padding: 32px 24px;
}

.session-end h2 {
  color: #183b3b;
  margin: 0 0 8px;
}

.session-end p {
  color: #486363;
  margin: 0 0 20px;
}

.session-btn {
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  background: #0f766e;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/features/Games/GameSession/gameSession.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".session-wrap {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.session-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  background: #0f766e;\n  color: #fff;\n  border-radius: 12px;\n  margin-bottom: 16px;\n}\n\n.session-title {\n  font-weight: 700;\n}\n\n.session-clock {\n  margin-left: auto;\n  font-variant-numeric: tabular-nums;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.session-clock-low {\n  color: #fde68a;\n}\n\n.session-quit {\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background: transparent;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.session-end {\n  max-width: 480px;\n  margin: 40px auto;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #d7e6e3;\n  border-radius: 16px;\n  padding: 32px 24px;\n}\n\n.session-end h2 {\n  color: #183b3b;\n  margin: 0 0 8px;\n}\n\n.session-end p {\n  color: #486363;\n  margin: 0 0 20px;\n}\n\n.session-btn {\n  padding: 10px 20px;\n  border-radius: 10px;\n  border: none;\n  background: #0f766e;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
